// ABOUTME: Full-screen celebration overlay for level-up moments
// ABOUTME: Shows level badge and auto-dismisses after a delay

import { useCallback, useEffect } from 'react'

interface LevelUpCelebrationProps {
  level: number
  isActive: boolean
  onComplete: () => void
  xpGained?: number
  autoDismissMs?: number
}

export function LevelUpCelebration({
  level,
  isActive,
  onComplete,
  xpGained,
  autoDismissMs = 4000,
}: LevelUpCelebrationProps) {
  useEffect(() => {
    if (!isActive) return

    const timer = setTimeout(onComplete, autoDismissMs)
    return () => clearTimeout(timer)
  }, [isActive, onComplete, autoDismissMs])

  const handleDismiss = useCallback(() => {
    onComplete()
  }, [onComplete])

  if (!isActive) return null

  return (
    <button
      type="button"
      className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-scrim/50 cursor-pointer"
      onClick={handleDismiss}
      aria-label="Dismiss celebration"
    >
      {/* Level Badge */}
      <div className="relative flex flex-col items-center">
        <div className="w-32 h-32 rounded-full bg-editorial-gold flex items-center justify-center shadow-2xl">
          <span className="text-5xl font-bold text-white uppercase tracking-wider">{level}</span>
        </div>

        <div className="mt-6 text-center">
          <h2 className="text-3xl font-bold text-white uppercase tracking-wider">LEVEL {level}</h2>
          <p className="mt-2 text-lg text-white/80">Congratulations!</p>
        </div>

        {!!xpGained && (
          <div className="mt-4 px-4 py-2 rounded-full bg-white/10">
            <span className="text-[var(--color-xp)] font-semibold">
              +{xpGained.toLocaleString()} XP
            </span>
          </div>
        )}
      </div>

      <p className="absolute bottom-8 text-white/60 text-sm">Tap anywhere to continue</p>
    </button>
  )
}
